import { useState } from "react";
import { useAuthContext } from "./useAuthContext";
import axios from "axios";
import Cookies from 'js-cookie';

export const useLogin = () => {
  const [error, setError] = useState(null);
  const [isLoading, setLoading] = useState(null);
  const { dispatch } = useAuthContext();

  const login = async (email, password, trustThisBrowser, twoFactorCode) => {
    setLoading(true);
    setError(null);
  
    const existingToken = Cookies.get('trustedBrowserToken') || localStorage.getItem('trustedBrowserToken');
    console.log('Starting auth with:', { trustThisBrowser, hasTwoFactorCode: !!twoFactorCode, existingToken });
  
    const payload = {
      email,
      password,
      trustThisBrowser,
      twoFactorCode,
    };
  
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/user/login`, 
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            'X-Trusted-Browser-Token': existingToken || ''
          },
          withCredentials: true
        }
      );
  
      console.log('Full response:', response);
      
      const { data } = response;
  
      if (response.status === 200) {
        if (data.requiresTwoFactorAuth) {
          return { requiresTwoFactorAuth: true, data, trustBrowser: trustThisBrowser };
        }
        
        if (data.token) {
          if (data.trustedBrowserToken) {
            const cookieOptions = {
              expires: 30,
              path: '/',
              secure: true,
              sameSite: 'none'
            };

            // Try to set the cookie
            Cookies.set('trustedBrowserToken', data.trustedBrowserToken, cookieOptions);
  
            // Verify cookie was set
            const afterCookie = Cookies.get('trustedBrowserToken');
            console.log('Cookie set verification:', afterCookie);
  
            // Use localStorage as backup
            if (!afterCookie) {
              console.log('Using localStorage fallback');
              localStorage.setItem('trustedBrowserToken', data.trustedBrowserToken);
            }
          }
          
          return { requiresTwoFactorAuth: false, data };
        }
      }
  
      setError(data?.error || "An error occurred during login.");
      return { requiresTwoFactorAuth: false, data: null };
    } catch (error) {
      console.error('Login error:', error);
      setError(error.response?.data?.error || error.message);
      return { requiresTwoFactorAuth: false, data: null };
    } finally {
      setLoading(false);
    }
  };

  return { login, isLoading, error };
};